import {take, range, partial} from 'lodash'
import Fade from '@mui/material/Fade'
import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {useDrop} from 'react-dnd'
import {Consumer} from '../../context'
import {reschedulePlan} from '../../context/post'
import Toolbar, {changeView} from './toolbar'
import Label from '../label'
import Event from './event'
import './month.styl'
import {newPlan} from 'planning/navigation'

const minEventHeight = 110
const minEventWidth = 130

const dayTitleHeight = 28
const eventHeight = 28
const viewMoreHeight = 20
const horizontalMargin = 40 
const verticalMargin = 300

function Day (props) {
  const {date, daySize, goToDay, defaultDate} = props
  const day = moment(date).format('YYYY-MM-DD')
  const isToday = moment(date).isSame(new Date(), 'day')
  const canAdd = moment(date).isSameOrAfter(new Date(), 'day')
  const className=`day ${isToday ? 'current' : ''}`
  const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight)
  const [collectedProps, drop] = useDrop({
    accept: 'event',
    canDrop: () => {
      return moment(date).isSameOrAfter(new Date(), 'day')
    },
    drop: ({id}) => {
      const event = props.context.plans.find(e => e.id == id)
      if (event) {
        const start = moment(date.toDate())
        const duration = Math.ceil(moment.duration(moment(event.finish).diff(moment(event.start))).asDays())
        const finish = moment(start).add(duration, 'days')
        reschedulePlan(id, start, finish).then(() => {
          const planUpdates = props.context.planUpdates + 1
          props.context.setState({planUpdates})
        })
      }
    }
  })
  return (<Consumer>{ context => {
    const events = context.plansByDay[day] || []
    return (
      <div
        ref={drop}
        className={className}
        style={daySize}
        onClick={() => { goToDay({start: day, end: day}) }}
      >
        <div className="title">
          {date.format('D')}
        </div>
        {/* <Fade in={context.plansUpdated}> */}
          <div className="events">
            {take(events, displayCount).map((props, i) => (<Event key={i} {...{...props, day, date, defaultDate}}/>))}
          </div>
        {/* </Fade> */}
        <div style={{flexGrow: 1}} />
          <div className="view-more">
            {events.length > displayCount && (<span className="more-button">
              <Text id="view-more" /> {events.length - displayCount}...
            </span>)}
            <span style={{flexGrow: 1}} />
            {canAdd && <span className="add-plan" onClick={e => {
              e.stopPropagation()
              const suggestedDate = moment(date).toISOString()
              const suggestedGroup = context.query.group
              newPlan(context, suggestedDate, suggestedGroup)
            }}>+</span>}
          </div>
      </div>
    )
  }}</Consumer>)
}

function Week(props) {
  const {start, daySize, context, goToDay, defaultDate} = props 
  const days = range(7)
    .map(d => ({goToDay, context, daySize, date: moment(start).add(d, 'days')}))
    .map((props,i) => (<Day key={i} defaultDate={defaultDate} {...props}/>))
  return (
    <div className="week">
      {days}
    </div>
  )
}

function Header(props) {
  const {date, daySize} = props
  return (
    <div
      className="header week"
      style={{width: daySize.width}}
    >
      {date.format('ddd')}
   </div>)
}



export default function MonthView (props) {

  const {date} = props
  const start = date().startOf('month').startOf('week')
  const end = date().endOf('month').endOf('week')
  const weekCount = Math.ceil(end.diff(start, 'days') / 7)

  return (<Consumer>{ context => {
    const {sizes} = context
    const goToDay = partial(changeView(context, 'month', {...context.query}), 'day')
    const daySize = {
      width: Math.max(minEventWidth, Math.round((sizes.width - horizontalMargin) / 7)),
      height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / weekCount))
    }
    const weeks = range(weekCount)
      .map(w => ({goToDay, context, start: moment(start).add(w, 'weeks'), daySize}))
      .map((props,i) => (<Week key={i} {...{...props, defaultDate: date}}/>))

    const headers = range(7)
      .map(d => ({date: moment(start).add(d, 'days'), daySize}))
      .map((props,i) => (<Header key={i} {...props}/>))

    return (
      <div className="planning month view" style={{width: sizes.width - horizontalMargin}}>
        <Toolbar {...props} />
        <div className="calendar">
          <div className="headers">
            {headers}
          </div>
          <div className="weeks">
            {weeks}
          </div>
        </div>
      </div>
    )}}</Consumer>)
}
